import classesPartners from "../../../styles/popovers.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useMemo, useRef, useState } from "react";
import { FormatDateShort } from "utils/dateUtils";
import {
  FormatNumberOrNull,
  FormatNumberWithUnitOrNull
} from "utils/numberUtils";
import { useSelector } from "react-redux";
import {
  selectPartner,
  updatePartnersHasUnacknowledgedAdditionalItems
} from "../../Main/main.slice";
import { useAppDispatch } from "hooks/hooks";
import { getOutputForPrint as getOutputForPrintForConcrete } from "Dashboard/scenes/ConcreteBase/scenes/Output/outputSlice";
import { getOutputForPrint as getOutputForPrintForStock } from "Dashboard/scenes/Stock/secenes/Output/outputSlice";
import { IOutputListItem as IOutputListItemForConcrete } from "Dashboard/scenes/ConcreteBase/domain/IOutputListItem";
import { IOutput as IOutputForStock } from "Dashboard/scenes/Stock/domain/IOutput";
import PrintBillOfLandingForConcrete from "Dashboard/scenes/ConcreteBase/scenes/Output/components/PrintBillOfLanding";
import PrintBillOfLandingForStock from "Dashboard/scenes/Stock/secenes/Output/components/PrintBillOfLanding";
import { IAcknowledgeRequestParams } from "Dashboard/scenes/Partners/domain/receivables/IAcknowledgeRequestParams";
import { toast } from "react-toastify";
import { debouncePerRow } from "utils/debounceUtil";
import {
  getReceivablesAdditionalInfo,
  selectState,
  updateAcknowledgedConcreteItemTemporarily,
  updateAcknowledgedStockItemTemporarily,
  updateReceivablesAdditionalInfoForConcrete,
  updateReceivablesAdditionalInfoForStock
} from "../accountReceivable.slice";
import { selectState as selectStateAuth } from "authentication/main.slice";
import { hasWriteAccessTo } from "utils/authUtil";
import { PARTNER_MODULE_NAME } from "Dashboard/scenes/Partners/domain/PartnerModule";
import { usePagePrint } from "hooks/usePagePrint";


export const ReceivablesAdditionalInfoPopover = () => {
  const componentRefBillOfLandingForConcrete = useRef<HTMLDivElement>(null);
  const componentRefBillOfLandingForStock = useRef<HTMLDivElement>(null);
  const [
    outputIdToPrintBillOfLandingForConcrete,
    setOutputIdToPrintBillOfLandingForConcrete
  ] = useState<number | null>(null);
  const [
    outputIdToPrintBillOfLandingForStock,
    setOutputIdToPrintBillOfLandingForStock
  ] = useState<number | null>(null);
  const { receivablesAdditionalInfo } = useSelector(selectState);
  const { user } = useSelector(selectStateAuth);
  const partner = useSelector(selectPartner);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (partner) {
      dispatch(getReceivablesAdditionalInfo(partner.partnerId));
    }
  }, [dispatch, partner, partner?.partnerId]);

  useEffect(() => {
    if (receivablesAdditionalInfo !== undefined) {
      const allConcreteAcknowledged = receivablesAdditionalInfo.concrete.items.every((item) => item.isAcknowledged);
      const allStockAcknowledged = receivablesAdditionalInfo.stock.items.every((item) => item.isAcknowledged);
      const allAcknowledged = allConcreteAcknowledged && allStockAcknowledged;
      dispatch(updatePartnersHasUnacknowledgedAdditionalItems({ partnerId: partner.partnerId, hasUnacknowledgedAdditionalItems: !allAcknowledged }));
    }
  }, [dispatch, partner?.partnerId, receivablesAdditionalInfo]);

  const handlePrintBillOfLandingForConcrete = usePagePrint(
    componentRefBillOfLandingForConcrete, { landscape: true, margins: "0" });

  const handlePrintBillOfLandingForStock = usePagePrint(
    componentRefBillOfLandingForStock, { landscape: true, margins: "0" });

  const printBillOfLandingForConcrete = (outputId: number) => {
    setOutputIdToPrintBillOfLandingForConcrete(outputId);
    dispatch(getOutputForPrintForConcrete(outputId));
  };

  const doPrintBillOfLandingForConcrete = (outputListItemToPrint: IOutputListItemForConcrete | undefined) => {
    if (outputIdToPrintBillOfLandingForConcrete === outputListItemToPrint?.outputId) {
      handlePrintBillOfLandingForConcrete();
      setOutputIdToPrintBillOfLandingForConcrete(null);
    }
  }

  const printBillOfLandingForStock = (outputId: number) => {
    setOutputIdToPrintBillOfLandingForStock(outputId);
    dispatch(getOutputForPrintForStock(outputId));
  };

  const doPrintBillOfLandingForStock = (outputListItemToPrint: IOutputForStock | undefined) => {
    if (outputIdToPrintBillOfLandingForStock === outputListItemToPrint?.outputId) {
      handlePrintBillOfLandingForStock();
      setOutputIdToPrintBillOfLandingForStock(null);
    }
  }

  const onChangeAcknowledgeForConcrete = (data: IAcknowledgeRequestParams) => {
    dispatch(updateAcknowledgedConcreteItemTemporarily(data));
    updateConcreteFieldWithDelay(data);
  };


  const onChangeAcknowledgeForStock = (data: IAcknowledgeRequestParams) => {
    dispatch(updateAcknowledgedStockItemTemporarily(data));
    updateStockFieldWithDelay(data);
  };

  const updateConcreteFieldWithDelay = useMemo(
    () => debouncePerRow(async (data: IAcknowledgeRequestParams) => {
      try {
        dispatch(updateReceivablesAdditionalInfoForConcrete(data)).unwrap();
        toast.success("Izmena je uspešno zabeležena.");
      } catch (status: any) {
        if (status === 403) {
          toast.error("Neočekivana greška");
        } else if (status === 400) {
          toast.error("Neočekivana greška");
        }
      }
    }, 1000, "outputItemId"),
    [dispatch]
  );

  const updateStockFieldWithDelay = useMemo(
    () => debouncePerRow(async (data: IAcknowledgeRequestParams) => {
      try {
        await dispatch(updateReceivablesAdditionalInfoForStock(data)).unwrap();
        toast.success("Izmena je uspešno zabeležena.");
      } catch (status: any) {
        if (status === 403) {
          toast.error("Neočekivana greška");
        } else if (status === 400) {
          toast.error("Neočekivana greška");
        }
      }
    }, 1000, "outputItemId"),
    [dispatch]
  );

  return (
    <div className={classesPartners.detailsAdditionalInfoPopover}>
      <div className={classesPartners.column}>
        <div className={classesPartners.headerContainer}>
          <h1>BETON</h1>
        </div>
        <div className={classesPartners.itemsContainer}>
          {receivablesAdditionalInfo && receivablesAdditionalInfo.concrete.items.map((item, index) => {
            return (
              <div className={classesPartners.item}>
                <div className={classesPartners.itemTitle}>{item.title}</div>
                <div className={classesPartners.itemButtons}>
                  <input type="checkbox"
                    checked={item.isAcknowledged}
                    onChange={hasWriteAccessTo(user, PARTNER_MODULE_NAME)
                      ? (event) => onChangeAcknowledgeForConcrete({
                        outputId: item.outputId,
                        outputItemId: item.outputItemId,
                        isAcknowledged: event.target.checked
                      })
                      : undefined}
                    disabled={!hasWriteAccessTo(user, PARTNER_MODULE_NAME)}
                  />
                  <FontAwesomeIcon
                    fontSize={13}
                    icon={faPrint}
                    onClick={() => printBillOfLandingForConcrete(item.outputId)} />
                </div>

                <div className={`${classesPartners.itemRow2Value} ${classesPartners.value} ${classesPartners.alignRight}`}>{item.billOfLandingId}</div>
                <div className={`${classesPartners.itemRow2Label} ${classesPartners.label}`}>br.otpremnice</div>
                <div className={`${classesPartners.itemRow2Value2} ${classesPartners.value}`}>{FormatDateShort(item.date)}</div>

                <div className={`${classesPartners.itemRow3Value} ${classesPartners.value} ${classesPartners.alignRight}`}>{FormatNumberOrNull(item.quantityAmount)}</div>
                <div className={`${classesPartners.itemRow3Label} ${classesPartners.label}`}>
                  <span className={classesPartners.importantLabel}>{item.quantityUnit.name}</span>&nbsp;nabavljeno
                </div>

                <div className={`${classesPartners.itemRow4Value} ${classesPartners.value} ${classesPartners.alignRight}`}>{FormatNumberWithUnitOrNull(item.totalPrice, 'rsd')}</div>
                <div className={`${classesPartners.itemRow4Label} ${classesPartners.label}`}>cena</div>

              </div>
            );
          })}
        </div>
      </div>
      <div className={classesPartners.column}>
        <div className={classesPartners.headerContainer}>
          <h1>LAGER</h1>
        </div>
        <div className={classesPartners.itemsContainer}>
          {receivablesAdditionalInfo && receivablesAdditionalInfo.stock.items.map((item, index) => {
            return (
              <div className={classesPartners.item}>
                <div className={classesPartners.itemTitle}>{item.title}</div>
                <div className={classesPartners.itemButtons}>
                  <input type="checkbox"
                    checked={item.isAcknowledged}
                    onChange={hasWriteAccessTo(user, PARTNER_MODULE_NAME)
                      ? (event) => onChangeAcknowledgeForStock({
                        outputId: item.outputId,
                        outputItemId: item.outputItemId,
                        isAcknowledged: event.target.checked
                      })
                      : undefined}
                    disabled={!hasWriteAccessTo(user, PARTNER_MODULE_NAME)}
                  />
                  <FontAwesomeIcon fontSize={13} icon={faPrint} onClick={() => printBillOfLandingForStock(item.outputId)} />
                </div>

                <div className={`${classesPartners.itemRow2Value} ${classesPartners.value} ${classesPartners.alignRight}`}>{item.billOfLandingId}</div>
                <div className={`${classesPartners.itemRow2Label} ${classesPartners.label}`}>br.otpremnice</div>
                <div className={`${classesPartners.itemRow2Value2} ${classesPartners.value}`}>{FormatDateShort(item.date)}</div>

                <div className={`${classesPartners.itemRow3Value} ${classesPartners.value} ${classesPartners.alignRight}`}>{FormatNumberOrNull(item.quantityAmount)}</div>
                <div className={`${classesPartners.itemRow3Label} ${classesPartners.label}`}>
                  <span className={classesPartners.importantLabel}>{item.quantityUnit.name}</span>&nbsp;izdato
                </div>

                <div className={`${classesPartners.itemRow4Value} ${classesPartners.value} ${classesPartners.alignRight}`}>{FormatNumberWithUnitOrNull(item.totalPrice, 'rsd')}</div>
                <div className={`${classesPartners.itemRow4Label} ${classesPartners.label}`}>cena</div>

              </div>
            );
          })}
        </div>
      </div>
      <div ref={componentRefBillOfLandingForConcrete} className="print-area">
        <PrintBillOfLandingForConcrete doPrint={doPrintBillOfLandingForConcrete} />
      </div>
      <div ref={componentRefBillOfLandingForStock} className="print-area">
        <PrintBillOfLandingForStock doPrint={doPrintBillOfLandingForStock} />
      </div>
    </div>
  );
};
